export const I18N_CONFIG = {
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'it'] as const,
  fallbackLanguage: 'en',
  namespaces: ['common'] as const,
  defaultNamespace: 'common',
} as const

export type SupportedLanguage = (typeof I18N_CONFIG.supportedLanguages)[number]

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  it: 'Italiano',
}
